import React from 'react';
import './LoadingIndicator.scss';
const LoadingIndicator = ({ size = 24, color = 'var(--base-600, var(--v-600, #333))', customClass = '', gap = 10 }) => {
    return (React.createElement("div", { className: `loading-indicator flex ${customClass}`, style: { height: size, gap: `${gap}px` } },
        React.createElement("span", { style: {
                width: size,
                height: size,
                backgroundColor: color
            } }),
        React.createElement("span", { style: {
                width: size,
                height: size,
                backgroundColor: color
            } }),
        React.createElement("span", { style: {
                width: size,
                height: size,
                backgroundColor: color
            } })));
};
export default LoadingIndicator;
